import MicroModal from 'micromodal';

const MODAL_ID = 'modal-popup-link';

function createModal() {
    if (document.getElementById(MODAL_ID)) return;

    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'popup-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
        <div class="popup-modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="popup-modal__container" role="dialog" aria-modal="true" aria-labelledby="${MODAL_ID}-title">
                <div class="popup-modal__header">
                    <h2 class="popup-modal__title" id="${MODAL_ID}-title"></h2>
                    <button class="popup-modal__close" aria-label="Close modal" data-micromodal-close>&#x2715;</button>
                </div>
                <iframe class="popup-modal__iframe" src="" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
}

export function initPopupLinks() {
    const triggers = document.querySelectorAll('[data-popup-url]');
    if (!triggers.length) return;

    createModal();

    const iframe = document.querySelector(`#${MODAL_ID} .popup-modal__iframe`);
    const titleEl = document.querySelector(`#${MODAL_ID} .popup-modal__title`);

    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (iframe) iframe.src = trigger.dataset.popupUrl;
            if (titleEl) titleEl.textContent = trigger.dataset.popupTitle || '';

            MicroModal.show(MODAL_ID, {
                disableScroll: true,
                onClose: () => {
                    if (iframe) iframe.src = '';
                },
            });
        });
    });
}
